<template>
  <v-container>
    <a-authorization-card
      class="ma-5"
      color="secondary"
      icon="mdi-logout"
      title="Fin de session"
      text="Vous êtes déconnecté de l'application."
    >
      <p>
        <router-link to="/accueil">Cliquer ici</router-link> pour vous reconnecter.
      </p>
    </a-authorization-card>
  </v-container>
</template>

<script>
import { oauth2Service } from "@/services";
export default {
  mounted() {
    if (oauth2Service.logged()) {
      oauth2Service.logout();
    }
  },
};
</script>
